<template>
  <Modules class="end" :pageModules="pageModulesListEnd" />
</template>

<script lang="ts">
import { RouteGuardHandler } from '../../mixins/route-guard-handler'
import { Component, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { PageModule, PageModuleData } from '../../types'

@Component({
  components: {
  }
})
export default class Result extends Mixins(RouteGuardHandler) {
  @Getter pageModulesListEnd!: PageModule<PageModuleData>
  @Action('CAMPAIGN_GET_SETLIST') getSetlist!: () => Promise<void>

  created () {
    this.getSetlist()
  }
}
</script>
